import axios from "axios";
import config from "./../config";

// withCredentials is set globally in authHelper; no token read from localStorage.
const JSON_HEADERS = { "Content-Type": "application/json" };

const getDataOverCategory = async (end_Point) =>
  axios.get(`${config.BASE_URL}/${end_Point}`, { headers: JSON_HEADERS });

const getDataProductsWithParams = async (end_Point) =>
  axios.get(`${config.BASE_URL}/${end_Point}`, { headers: JSON_HEADERS });

const getDeliveryAddress = async (end_Point) =>
  axios.get(`${config.BASE_URL}/${end_Point}`, { headers: JSON_HEADERS });

const getCollectionPoint = async (end_Point) =>
  axios.get(`${config.BASE_URL}/${end_Point}`, { headers: JSON_HEADERS });

const getSlots = async (end_Point) =>
  axios.get(`${config.BASE_URL}/${end_Point}`, { headers: JSON_HEADERS });

const getBags = async (end_Point) =>
  axios.get(`${config.BASE_URL}/${end_Point}`, { headers: JSON_HEADERS });

const getRetrieve = async (end_Point) =>
  axios.get(`${config.BASE_URL}/${end_Point}`, { headers: JSON_HEADERS });

const ApiServiceHelper = {
  getDataOverCategory,
  getDataProductsWithParams,
  getDeliveryAddress,
  getCollectionPoint,
  getSlots,
  getBags,
  getRetrieve
};

export default ApiServiceHelper;
